var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeFooter = function SvgYoutubeFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.2,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.013 10.381c.774.208 1.386.82 1.594 1.595.381 1.41.393 4.332.393 4.332s0 2.935-.381 4.333a2.27 2.27 0 0 1-1.595 1.594c-1.398.381-7.024.381-7.024.381s-5.626 0-7.024-.381A2.27 2.27 0 0 1 7.38 20.64C7 19.23 7 16.308 7 16.308s0-2.923.37-4.32a2.27 2.27 0 0 1 1.594-1.595c1.398-.381 7.024-.393 7.024-.393s5.627 0 7.025.381m-4.148 5.927-4.667 2.704v-5.407z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutubeFooter;